// import type { SendEventParams } from '~/shared/analytix'
import { SnapshotMap } from '../../general/snapshot-map'

const SNAPSHOTS_TO_KEEP = 0

export type SessionEndParameters = Record<never, never> // SendEventParams.SessionEnd

/**
 * SnapshotMap to store `session_end` event parameters with their history
 */
export const parameters = new SnapshotMap<SessionEndParameters>(
  SNAPSHOTS_TO_KEEP
)
